(() => {
  const root = document.querySelector('[data-mm-version="2"]');
  if (!root) return;

  const atcBtn = root.querySelector('#mixAndMatchATC');
  if (!atcBtn) return;

  // ── DOM refs ──────────────────────────────────────────────────────────────
  const el = {
    atcBtn,
    overlay:         root.querySelector('.MixAndMatch-Overlay'),
    overlayCollapseToggle: root.querySelector('[data-mm-collapse-toggle]'),
    thumbnails:      root.querySelector('.MixAndMatch-Overlay--Thumbnails'),
    selectedCount:   root.querySelector('[data-mm-selected]'),
    overlayHeader:   root.querySelector('[data-mm-toggle]'),
    overlayBody:     root.querySelector('[data-mm-body]'),
    overlayPrices:   root.querySelector('.MixAndMatch-Overlay--Prices'),
    overlayPrice:    root.querySelector('.MixAndMatch-Overlay--PriceStack .MixAndMatch-ProductPrice'),
    overlaySubPrice: root.querySelector('.MixAndMatch-Overlay--PriceStack .MixAndMatch-ProductSubPrice'),
    overlaySaving:   root.querySelector('.MixAndMatch-Overlay--Prices .MixAndMatch-SavingATC'),
    progressBar:     root.querySelector('[data-mm-progress]'),
    progressLabel:   root.querySelector('[data-mm-progress-label]'),
    progressFill:        root.querySelector('[data-mm-progress-fill]'),
    progressFillCurrent: root.querySelector('[data-mm-progress-fill-current]'),
    progressTicks:   root.querySelector('[data-mm-progress-ticks]'),
    countCheck:      root.querySelector('[data-mm-count-check]'),
    popup:           document.querySelector('[data-mm-popup="2"]'),
    popupContent:    document.querySelector('[data-mm-popup="2"] .MixAndMatchProduct--Popup-Content'),
    // Subscription elements cached once
    subToggle:       root.querySelector('#mmSubscriptionToggle'),
    subFreqSelect:   root.querySelector('[data-mm-freq-select]'),
    subBadge:        root.querySelector('[data-mm-sub-badge]'),
  };

  const MILESTONES = JSON.parse(root.dataset.mmMilestones || '[]').map(m => ({
    count:    m.count,
    label:    m.label  || '',
    achieved: m.achieved || '',
  }));
  const COMPLETION_LABEL = root.dataset.mmCompletion;

  // ── SVG template (parsed once, cloned per use) ────────────────────────────
  const removeIconTpl = document.createElement('template');
  removeIconTpl.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><circle cx="7" cy="7" r="6.5" fill="white" stroke="#EFEFEF"/><line x1="4.47482" y1="9.42464" x2="9.42456" y2="4.4749" stroke="black"/><line x1="9.42464" y1="9.42466" x2="4.4749" y2="4.47491" stroke="black"/></svg>';

  // ── Observe programmatic value changes on an input ────────────────────────
  function observeInputValue(input, callback) {
    const proto = Object.getPrototypeOf(input);
    if (!proto.hasOwnProperty('value')) return;
    const descriptor = Object.getOwnPropertyDescriptor(proto, 'value');
    Object.defineProperty(input, 'value', {
      get() { return descriptor.get.call(this); },
      set(next) {
        const prev = descriptor.get.call(this);
        descriptor.set.call(this, next);
        callback(prev, descriptor.get.call(this));
      },
    });
  }

  // ── Thumbnail strip ───────────────────────────────────────────────────────
  function renderThumbnails(inputElements) {
    const slots = [];

    inputElements.forEach(input => {
      const qty = parseInt(input.value, 10) || 0;
      if (!qty) return;

      const productItem = input.closest('.ProductItem');
      if (!productItem) return;

      const imgEl = productItem.querySelector('.ProductItem__Image:not(.ProductItem__Image--alternate)');
      const imgSrc = imgEl
        ? (imgEl.currentSrc || (imgEl.dataset.src ? imgEl.dataset.src.replace('{width}', '120') : ''))
        : '';

      const name = productItem.querySelector('.ProductItem__Title')?.textContent.trim() ?? '';

      for (let i = 0; i < qty; i++) slots.push({ imgSrc, name, input });
    });

    const fragment = document.createDocumentFragment();

    slots.forEach(({ imgSrc, name, input }) => {
      const thumb = document.createElement('div');
      thumb.className = 'MixAndMatch-Overlay--Thumbnail';

      if (imgSrc) {
        const img = document.createElement('img');
        img.src = imgSrc;
        img.alt = name;
        thumb.appendChild(img);
      }

      const nameEl = document.createElement('span');
      nameEl.className = 'MixAndMatch-Overlay--Thumbnail-Name';
      nameEl.textContent = name;
      thumb.appendChild(nameEl);

      const removeBtn = document.createElement('button');
      removeBtn.className = 'MixAndMatch-Overlay--Thumbnail-Remove';
      removeBtn.appendChild(removeIconTpl.content.cloneNode(true));
      removeBtn.addEventListener('click', e => {
        e.preventDefault();
        input.value = Math.max(parseInt(input.value, 10) - 1, 0);
      });

      thumb.appendChild(removeBtn);
      fragment.appendChild(thumb);
    });

    const isDesktop = window.innerWidth >= 1001;
    const totalSlots = isDesktop
      ? Math.max(4, Math.ceil(slots.length / 4) * 4)
      : Math.max(8, Math.ceil((slots.length + 1) / 2) * 2);
    for (let i = slots.length; i < totalSlots; i++) {
      const empty = document.createElement('div');
      empty.className = 'MixAndMatch-Overlay--Thumbnail MixAndMatch-Overlay--Thumbnail--empty';
      fragment.appendChild(empty);
    }

    el.thumbnails.replaceChildren(fragment);
    requestAnimationFrame(syncScrollThumb);
  }

  // ── Custom scrollbar (macOS hides native scrollbars, so we build our own) ──
  let syncScrollThumb = () => {};

  function initCustomScrollbar() {
    const wrapper = document.createElement('div');
    wrapper.className = 'MixAndMatch-Thumbnails-Wrapper';
    el.thumbnails.parentNode.insertBefore(wrapper, el.thumbnails);
    wrapper.appendChild(el.thumbnails);

    const track = document.createElement('div');
    track.className = 'MixAndMatch-Scrollbar--Track';
    track.hidden = true;
    const thumb = document.createElement('div');
    thumb.className = 'MixAndMatch-Scrollbar--Thumb';
    track.appendChild(thumb);
    wrapper.appendChild(track);

    function update() {
      const { scrollTop, scrollHeight, clientHeight } = el.thumbnails;
      const hasOverflow = clientHeight > 0 && scrollHeight > clientHeight;
      track.hidden = !hasOverflow;
      wrapper.classList.toggle('has-overflow', hasOverflow);
      if (!hasOverflow) return;
      const thumbH   = Math.max(20, (clientHeight / scrollHeight) * clientHeight);
      const thumbTop = (scrollTop / (scrollHeight - clientHeight)) * (clientHeight - thumbH);
      thumb.style.height    = `${thumbH}px`;
      thumb.style.transform = `translateY(${thumbTop}px)`;
    }

    el.thumbnails.addEventListener('scroll', update);
    syncScrollThumb = update;
  }

  // ── Quantity +/- buttons ──────────────────────────────────────────────────
  function syncQuickAddState(field) {
    const selector = field.closest('.product-quantity-selector');
    if (!selector) return;
    const qty = parseInt(field.value, 10);
    const btn = selector.querySelector('.ProductItem-QuickAdd-mm');
    const qs  = selector.querySelector('.QuantitySelector');
    if (qty > 0) {
      if (btn) btn.style.display = 'none';
      if (qs)  qs.style.display  = '';
    } else {
      if (btn) btn.style.display = '';
      if (qs)  qs.style.display  = 'none';
    }
  }

  function initQuantityButtons(scope = root) {
    scope.querySelectorAll('[data-action="decrease-quantity-null"]').forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault();
        const field = e.currentTarget.closest('.QuantitySelector').querySelector('.QuantitySelector__CurrentQuantity');
        field.value = Math.max(parseInt(field.value, 10) - 1, 0);
        syncQuickAddState(field);
      });
    });

    scope.querySelectorAll('[data-action="increase-quantity"]').forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault();
        const field = e.currentTarget.closest('.QuantitySelector').querySelector('.QuantitySelector__CurrentQuantity');
        field.value = parseInt(field.value, 10) + 1;
        syncQuickAddState(field);
      });
    });

    scope.querySelectorAll('[data-action="quick-add"]').forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault();
        const selector = e.currentTarget.closest('.product-quantity-selector');
        const field = selector.querySelector('.QuantitySelector__CurrentQuantity');
        field.value = 1;
        syncQuickAddState(field);
      });
    });
  }

  // ── Product popup ─────────────────────────────────────────────────────────
  function closePopup() {
    el.popup.setAttribute('aria-hidden', 'true');
    el.popupContent.replaceChildren();
  }

  // Swaps the popup's default quantity form for the same +/- stepper used on the
  // product cards. It stays in sync with the matching card's quantity field live,
  // without closing the popup, so the shopper can keep adjusting it in place.
  function initPopupQuickAdd() {
    const oldSelector = el.popupContent.querySelector('.ProductForm__QuantitySelector');
    const addToBoxBtn = el.popupContent.querySelector('#addToBox');
    if (!oldSelector || !addToBoxBtn) return;

    const productId = addToBoxBtn.dataset.productId;
    const numberBox = root.querySelector(`[data-sku='${productId}']`);
    const currentQty = numberBox ? parseInt(numberBox.value, 10) || 0 : 0;

    const wrapper = document.createElement('div');
    wrapper.className = 'product-quantity-selector';
    wrapper.dataset.productId = productId;
    wrapper.innerHTML = `
      <button class="ProductItem-QuickAdd-mm" type="button" data-action="quick-add" aria-label="Hinzufügen" style="${currentQty > 0 ? 'display:none;' : ''}">
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M3.84229 9.60222V-5.60284e-05H5.7528V9.60222H3.84229ZM-4.43757e-05 5.75279V3.84227H9.60223V5.75279H-4.43757e-05Z" fill="currentColor"/></svg>
      </button>
      <div class="QuantitySelector" style="${currentQty > 0 ? '' : 'display:none;'}">
        <button class="QuantitySelector__Button" type="button" data-action="decrease-quantity-null">
          <svg xmlns="http://www.w3.org/2000/svg" width="10" height="2" viewBox="0 0 10 2" fill="none"><path d="M10 1.06096e-05V1.8395H0V1.06096e-05H10Z" fill="currentColor"/></svg>
        </button>
        <input type="text" disabled class="QuantitySelector__CurrentQuantity" pattern="[0-9]*" name="quantity" value="${currentQty}">
        <button class="QuantitySelector__Button" type="button" data-action="increase-quantity">
          <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M3.84229 9.60222V-5.60284e-05H5.7528V9.60222H3.84229ZM-4.43757e-05 5.75279V3.84227H9.60223V5.75279H-4.43757e-05Z" fill="currentColor"/></svg>
        </button>
      </div>
    `;

    oldSelector.replaceWith(wrapper);
    addToBoxBtn.remove();

    wrapper.addEventListener('click', e => {
      if (!e.target.closest('[data-action]')) return;
      const field = wrapper.querySelector('.QuantitySelector__CurrentQuantity');
      if (numberBox) {
        numberBox.value = parseInt(field.value, 10) || 0;
        syncQuickAddState(numberBox);
      }
    });
  }

  function initPopupReviews(sku) {
    // an empty div#ReviewsWidget makes the bare name resolve to that element, so check for the constructor
    if (typeof ReviewsWidget !== 'function') return;
    new ReviewsWidget('.MixAndMatchProduct--Popup-Content #ReviewsWidget', {
      store: 'www.loewenanteil.com',
      widget: 'polaris',
      options: {
        types: 'product_review, questions',
        lang: 'de',
        layout: '',
        per_page: 5,
        product_review: { sku, hide_if_no_results: true },
        questions: { hide_if_no_results: false, enable_ask_question: true, show_dates: true },
        header: {
          enable_summary: true, enable_ratings: true, enable_attributes: false,
          enable_image_gallery: false, enable_percent_recommended: false,
          enable_write_review: false, enable_ask_question: true, enable_sub_header: true,
        },
        filtering: {
          enable: true, enable_text_search: false, enable_sorting: true,
          enable_overall_rating_filter: true, enable_ratings_filters: false,
          enable_attributes_filters: false,
        },
        reviews: {
          enable_avatar: false, enable_reviewer_name: true, enable_reviewer_address: false,
          reviewer_address_format: 'city, country', enable_verified_badge: true,
          enable_reviewer_recommends: false, enable_attributes: false, enable_product_name: false,
          enable_review_title: false, enable_replies: undefined, enable_images: false,
          enable_ratings: false, enable_share: false, enable_helpful_vote: false,
          enable_helpful_display: false, enable_report: false, enable_date: true,
        },
        text: { 'Verified Customer': 'Verified Customer' },
      },
      translations: { 'Verified Customer': 'Verifizierter Käufer' },
      styles: {
        '--base-font-size': '16px',
        '--common-button-font-family': 'inherit', '--common-button-font-size': '16px',
        '--common-button-font-weight': '500', '--common-button-letter-spacing': '0',
        '--common-button-text-transform': 'none', '--common-button-vertical-padding': '10px',
        '--common-button-horizontal-padding': '20px', '--common-button-border-width': '2px',
        '--common-button-border-radius': '0px',
        '--primary-button-bg-color': '#0E1311', '--primary-button-border-color': '#0E1311',
        '--primary-button-text-color': '#ffffff',
        '--secondary-button-bg-color': 'transparent', '--secondary-button-border-color': '#0E1311',
        '--secondary-button-text-color': '#0E1311',
        '--common-star-color': '#fbcd0a', '--common-star-disabled-color': 'rgba(0,0,0,0.25)',
        '--medium-star-size': '22px', '--small-star-size': '19px',
        '--heading-text-color': '#0E1311', '--heading-text-font-weight': '600',
        '--heading-text-font-family': 'inherit', '--heading-text-line-height': '1.4',
        '--heading-text-letter-spacing': '0', '--heading-text-transform': 'none',
        '--body-text-color': '#0E1311', '--body-text-font-weight': '400',
        '--body-text-font-family': 'inherit', '--body-text-line-height': '1.4',
        '--body-text-letter-spacing': '0', '--body-text-transform': 'none',
        '--photo-video-thumbnail-size': '80px', '--photo-video-thumbnail-border-radius': '0px',
      },
    });
  }

  // the popup runs without the product section script, so thumbnails need their own wiring
  function initPopupThumbnails(slideshowEl, flkty) {
    const thumbs = [...el.popupContent.querySelectorAll('.Product__SlideshowNavImage')];
    if (!thumbs.length) return;

    const cells = [...slideshowEl.querySelectorAll('.Product__SlideItem')];
    const imageIds = cells.map(cell => cell.dataset.imageId);

    const markSelected = () => {
      const imageId = imageIds[flkty.selectedIndex];
      thumbs.forEach(thumb => thumb.classList.toggle('is-selected', thumb.dataset.imageId === imageId));
    };

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', e => {
        e.preventDefault();
        const index = imageIds.indexOf(thumb.dataset.imageId);
        if (index > -1) flkty.select(index);
      });
    });

    // the Flickity build in theme.js fires select, not change
    flkty.on('select', markSelected);
    markSelected();
  }

  function initPopup() {
    if (!el.popup) return;

    root.querySelectorAll('.ProductItem__PopUp, .ProductItem__ImageWrapper--withAlternateImage').forEach(trigger => {
      trigger.addEventListener('click', async e => {
        e.preventDefault();
        const link = e.currentTarget.closest('.ProductItem__Wrapper').querySelector('.ProductItem__PopUp');
        el.popup.setAttribute('aria-hidden', 'false');

        try {
          const html = await fetch(link.href).then(r => r.text());
          el.popupContent.innerHTML = html;

          initPopupQuickAdd();

          if (typeof initPorductBars === 'function') initPorductBars();

          const reviewsSkuEl = el.popupContent.querySelector('#reviews-sku');
          // a blocked or half-loaded reviews script must not take the gallery down with it
          if (reviewsSkuEl) {
            const reviewsSku = reviewsSkuEl.dataset.sku;
            const loadPolaris = window.__reviewsioLoadPolaris || function (fn) { setTimeout(fn, 0); };
            loadPolaris(function () {
              try {
                initPopupReviews(reviewsSku);
              } catch (err) {
                console.warn('[MixMatch] Reviews widget failed:', err);
              }
            });
          }

          const slideshowEl = el.popupContent.querySelector('.Product__Slideshow');
          if (slideshowEl && typeof window.Flickity !== 'undefined') {
            const flkty = new window.Flickity(slideshowEl, {
              wrapAround: false, pageDots: true, cellAlign: 'left', prevNextButtons: false,
            });

            initPopupThumbnails(slideshowEl, flkty);
          }

          if (typeof ratingSnippet !== 'undefined') {
            try {
              ratingSnippet('MixAndMatchProduct--Popup-Content .ruk_rating_snippet', {
                store: 'www.loewenanteil.com', color: '#fbcd0a', linebreak: true, snippetPopup: false,
              });
            } catch (err) {
              console.warn('[MixMatch] Rating snippet failed:', err);
            }
          }

          initQuantityButtons(el.popupContent);

          el.popupContent.querySelector('.NewsletterPopup__Close')?.addEventListener('click', e => {
            e.preventDefault();
            closePopup();
          });
        } catch (err) {
          console.error('[MixMatch] Failed to load product popup:', err);
        }
      });
    });

    el.popup.addEventListener('click', e => {
      if (e.target === el.popup) closePopup();
    });
  }

  // ── Core: quantity tracking, pricing, ATC ────────────────────────────────
  function initCore() {
    let totalElements = 0;
    const subDefaultAttr = el.subToggle ? el.subToggle.dataset.mmSubDefault : null;
    let isSubscription = subDefaultAttr !== null ? subDefaultAttr !== 'false' : true;
    let selectedFrequencyIndex = '0';
    const items = {};

    // Cache inputs, prices, and product elements once — avoids repeated DOM queries
    const inputElements  = Array.from(root.querySelectorAll('.QuantitySelector__CurrentQuantity'));
    const priceCache     = new Map();
    const productElCache = new Map();

    inputElements.forEach(input => {
      const { sku } = input.dataset;
      priceCache.set(sku, Number(input.closest('[data-price]')?.dataset.price ?? 0));
      productElCache.set(sku, input.closest('.ProductItem'));
    });

    function discountFactor(count) {
      if (isSubscription) {
        if (count >= 18) return 0.85; // selling plan 15%
        if (count >= 12) return 0.90; // selling plan 10%
        return 0.95;                  // selling plan 5%
      }
      if (count >= 18) return 0.90;   // quantity discount 10%
      if (count >= 12) return 0.95;   // quantity discount 5%
      return 1.0;
    }

    function formatMoney(cents) {
      return window.Shopify.formatMoney(cents.toFixed(2));
    }

    const toEuro = cents => `€${(cents / 100).toFixed(2).replace('.', ',')}`;

    // ── Per-card price recalculation ──────────────────────
    let lastFactor = 1.0;

    function updateProductCardPrices(factor) {
      if (factor === lastFactor) return;
      lastFactor = factor;

      root.querySelectorAll('.ProductItem[data-price]').forEach(item => {
        const pricesEl = item.querySelector('.MixAndMatch-ProductItem--Prices');
        if (!pricesEl) return;

        const price     = parseInt(item.dataset.price, 10) || 0;
        const compareAt = parseInt(item.dataset.compareAtPrice, 10) || 0;

        let oldEl  = pricesEl.querySelector('.MixAndMatch-ProductItem--OldPrice');
        const newEl = pricesEl.querySelector('.MixAndMatch-ProductItem--Price');
        if (!newEl) return;

        if (factor < 1) {
          if (!oldEl) {
            oldEl = document.createElement('span');
            oldEl.className = 'MixAndMatch-ProductItem--OldPrice';
            pricesEl.insertBefore(oldEl, newEl);
          }
          oldEl.textContent = toEuro(price);
          oldEl.hidden = false;
          newEl.textContent = toEuro(Math.ceil(price * factor));
        } else {
          newEl.textContent = toEuro(price);
          if (oldEl) {
            if (compareAt > price) {
              oldEl.textContent = toEuro(compareAt);
              oldEl.hidden = false;
            } else {
              oldEl.hidden = true;
            }
          }
        }
      });
    }

    function milestoneAchieved(m, total) {
      return total >= m.count;
    }

    function applyPlaceholders(template, values) {
      return template.replace(/\{(\w+)\}/g, (_, key) => key in values ? `<strong>${values[key]}</strong>` : `{${key}}`);
    }

    // Track ends at the last milestone: nothing is earned past it, so the bar must not grow further
    const MAX_COUNT   = MILESTONES.length > 0 ? MILESTONES[MILESTONES.length - 1].count : 18;

    // Tick visual positions (% along track) — calculated once in initProgressTicks,
    // reused by updateProgress so fill always aligns exactly with each milestone marker.
    let tickPositions = [];

    function initProgressTicks() {
      if (!el.progressTicks || MILESTONES.length === 0) return;
      const n = MILESTONES.length;
      tickPositions = MILESTONES.map((m, i) => {
        const propPct = (m.count / MAX_COUNT) * 100;
        const evenPct = ((i + 1) / n) * 100;
        return (propPct + evenPct) / 2;
      });
      MILESTONES.forEach((m, i) => {
        const tick = document.createElement('div');
        tick.className = 'MixAndMatch-Overlay--Progress-Tick';
        // last tick sits on the right edge, its label would overflow if centered
        if (i === n - 1) tick.classList.add('MixAndMatch-Overlay--Progress-Tick--end');
        tick.style.left = `${tickPositions[i]}%`;
        const label = document.createElement('span');
        label.textContent = `${m.count} Gerichte`;
        tick.appendChild(label);
        el.progressTicks.appendChild(tick);
      });
    }

    // Piecewise-linear fill: interpolates between [0,0%] → milestone ticks → [MAX_COUNT,100%]
    // so the fill bar reaches each tick exactly when that milestone count is hit.
    function countToFillPct(total) {
      if (tickPositions.length === 0) return Math.min((total / MAX_COUNT) * 100, 100);
      const points = [{ count: 0, pct: 0 }];
      MILESTONES.forEach((m, i) => points.push({ count: m.count, pct: tickPositions[i] }));
      for (let i = 1; i < points.length; i++) {
        if (total <= points[i].count) {
          const t = (total - points[i - 1].count) / (points[i].count - points[i - 1].count);
          return points[i - 1].pct + t * (points[i].pct - points[i - 1].pct);
        }
      }
      return 100;
    }

    function updateProgress(total) {
      el.progressBar.classList.remove('is-complete');

      if (total <= 0) {
        el.progressBar.classList.remove('is-visible');
        return;
      }

      const next         = MILESTONES.find(m => !milestoneAchieved(m, total));
      const lastAchieved = [...MILESTONES].reverse().find(m => milestoneAchieved(m, total));

      const pct = Math.min(countToFillPct(total), 100);
      // Achieved portion is solid green; the stretch toward the next tier stays light green
      // until that tier is actually reached — full green only confirms a milestone was hit.
      const achievedPct = next
        ? (lastAchieved ? Math.min(countToFillPct(lastAchieved.count), 100) : 0)
        : pct;

      el.progressFillCurrent.style.width = `${pct.toFixed(2)}%`;
      el.progressFill.style.width        = `${achievedPct.toFixed(2)}%`;
      el.progressFill.classList.toggle('is-full', !next);
      el.progressFillCurrent.classList.toggle('is-hidden', !next);

      if (!next) {
        el.progressLabel.innerHTML = applyPlaceholders(lastAchieved?.achieved || COMPLETION_LABEL, {});
        el.progressBar.classList.add('is-visible', 'is-complete');
        return;
      }

      const remainingCount = next.count - total;
      const label = lastAchieved
        ? applyPlaceholders(lastAchieved.achieved, { count: remainingCount })
        : applyPlaceholders(next.label, { count: remainingCount });

      el.progressLabel.innerHTML = label;
      el.progressBar.classList.add('is-visible');
    }

    function updateUI() {
      if (el.overlay) el.overlay.style.display = totalElements > 0 ? '' : 'none';

      const factor = discountFactor(totalElements);

      // Round per-item price to match Shopify function rounding behavior (ceil per unit)
      const [totalOriginalCents, totalDiscountedCents] = Object.entries(items).reduce(
        ([orig, disc], [sku, qty]) => {
          const price = priceCache.get(sku) ?? 0;
          return [orig + price * qty, disc + Math.ceil(price * factor) * qty];
        },
        [0, 0]
      );

      const originalCents   = totalOriginalCents / 100;
      const discountedCents = totalDiscountedCents / 100;

      el.selectedCount.textContent = totalElements;
      el.overlayPrices.style.display = totalElements > 0 ? 'flex' : 'none';
      atcBtn.disabled = totalElements === 0;

      el.overlayPrice.textContent    = formatMoney(discountedCents);
      el.overlaySubPrice.textContent = formatMoney(originalCents);

      const hasDiscount = factor < 1;
      el.overlaySubPrice.style.display = hasDiscount ? 'inline' : 'none';
      el.overlaySaving.style.display   = hasDiscount ? 'flex'   : 'none';
      el.overlayPrices.classList.toggle('MixAndMatch-Overlay--Prices--has-saving', hasDiscount);
      if (hasDiscount) {
        el.overlaySaving.textContent = `-${Math.round((1 - factor) * 100)}%`;
      }

      // Checkmark: first milestone reached
      if (el.countCheck) {
        el.countCheck.hidden = !(MILESTONES.length > 0 && totalElements >= MILESTONES[0].count);
      }

      updateProgress(totalElements);
      updateProductCardPrices(factor);
      renderThumbnails(inputElements);
    }

    inputElements.forEach(input => {
      const { sku } = input.dataset;
      items[sku] = 0;

      observeInputValue(input, (prev, next) => {
        const delta = parseInt(next, 10) - parseInt(prev, 10);
        totalElements += delta;
        items[sku] = parseInt(next, 10);
        updateUI();
      });
    });

    // ── Subscription state helper ─────────────────────────────────────────
    function applySubscriptionState(enabled) {
      isSubscription = enabled;
      if (el.subToggle)     el.subToggle.checked     = enabled;
      if (el.subFreqSelect) el.subFreqSelect.hidden   = !enabled;
      if (el.subBadge)      el.subBadge.hidden        =  enabled;
    }

    // ── Cart sync (AbortController cancels stale in-flight requests) ──────
    let cartSyncController = null;

    async function fetchAndSync() {
      if (cartSyncController) cartSyncController.abort();
      cartSyncController = new AbortController();
      try {
        const cart = await fetch('/cart.js', { signal: cartSyncController.signal }).then(r => r.json());
        syncMm2QuantitiesToPage(cart.items);
      } catch (e) {
        if (e.name !== 'AbortError') console.warn('[MixMatch] cart sync failed', e);
      }
    }

    // Preselect M&M configuration from cart on page load
    function syncMm2QuantitiesToPage(cartItems) {
      const mm2Items = cartItems.filter(i => i.properties && i.properties['_is_mm']);

      // Restore subscription state FIRST — so updateUI uses correct discountFactor
      // Only override if cart has MM2 items (preserve true default when cart is empty)
      if (el.subToggle && mm2Items.length > 0) {
        const subscriptionItem = mm2Items.find(i => i.selling_plan_allocation);
        applySubscriptionState(!!subscriptionItem);

        // Restore frequency selection from cart
        if (subscriptionItem && el.subFreqSelect) {
          const cartSpId = String(subscriptionItem.selling_plan_allocation.selling_plan.id);
          const firstProductEl = productElCache.values().next().value;
          if (firstProductEl) {
            try {
              const plans = JSON.parse(firstProductEl.dataset.spBase || '{}');
              const matchedIndex = Object.entries(plans).find(([, id]) => String(id) === cartSpId)?.[0];
              if (matchedIndex !== undefined) {
                selectedFrequencyIndex = matchedIndex;
                el.subFreqSelect.value = matchedIndex;
              }
            } catch (e) {}
          }
        }
      }

      // Then set quantities — each triggers updateUI with correct isSubscription
      inputElements.forEach(input => {
        const matched = mm2Items.find(i => String(i.variant_id) === String(input.dataset.sku));
        input.value = matched ? matched.quantity : 0;
      });
    }

    fetchAndSync();

    document.addEventListener('mm2:cart:updated', e => {
      syncMm2QuantitiesToPage(e.detail.items);
    });

    document.addEventListener('theme:loading:end', fetchAndSync);

    atcBtn.addEventListener('click', async () => {
      const mm2Timestamp = Date.now();
      const cartItems = Object.entries(items)
        .filter(([, qty]) => qty > 0)
        .map(([sku, qty]) => {
          const item = { id: sku, quantity: qty, properties: { '_is_mm': true, '_mm_timestamp': mm2Timestamp, ...(isSubscription ? { '_is_mm_subscription': true } : {}) } };
          if (isSubscription) {
            const productEl = productElCache.get(sku);
            if (productEl) {
              try {
                const plans = JSON.parse(productEl.dataset.spBase || '{}');
                const sp = plans[selectedFrequencyIndex] ?? Object.values(plans)[0];
                if (sp) item.selling_plan = parseInt(sp, 10);
              } catch (e) {}
            }
          }
          return item;
        });

      try {
        const cart = await fetch('/cart.js').then(r => r.json());
        const oldMm2Keys = {};
        cart.items.forEach(item => {
          if (item.properties && item.properties['_is_mm']) {
            oldMm2Keys[item.key] = 0;
          }
        });
        if (Object.keys(oldMm2Keys).length > 0) {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: oldMm2Keys }),
          });
        }

        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: cartItems }),
        }).then(r => r.json());

        document.dispatchEvent(new CustomEvent('theme:loading:end'));

        res.items.forEach(item => {
          document.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: { variant: item.variant_id, quantity: item.quantity },
          }));
        });
      } catch (err) {
        console.error('[MixMatch] Failed to add items to cart:', err);
      }
    });

    el.overlayHeader.addEventListener('click', () => {
      const open = el.overlayBody.classList.toggle('is-open');
      el.overlayHeader.classList.toggle('is-open', open);
      if (open) setTimeout(syncScrollThumb, 320);
    });

    el.overlayCollapseToggle?.addEventListener('click', () => {
      el.overlay.classList.toggle('is-collapsed');
    });

    function initSubscriptionToggle() {

      if (!el.subToggle) return;

      // Handle browser form-state restoration (back navigation)
      if (el.subToggle.checked) applySubscriptionState(true);

      el.subToggle.addEventListener('change', () => {
        applySubscriptionState(el.subToggle.checked);
        updateUI();
      });

      if (el.subFreqSelect) {
        el.subFreqSelect.addEventListener('change', () => {
          selectedFrequencyIndex = el.subFreqSelect.value;
        });
      }
    }

    window.addEventListener('resize', () => {
      if (window.innerWidth < 1001) {
        el.overlayBody.classList.remove('is-open');
        el.overlayHeader.classList.remove('is-open');
      }
      scheduleMobileTitleHeights();
    });

    initProgressTicks();
    initCustomScrollbar();   // must run before updateUI so syncScrollThumb is set
    updateUI();
    initQuantityButtons(root);
    initPopup();
    applySubscriptionState(isSubscription)
    initSubscriptionToggle();
    initFilters();
    initMobileTitleHeights();
  }

  const TITLE_ALIGN_MQ = window.matchMedia('(max-width: 640px)');
  let titleAlignRaf = 0;

  function syncMobileTitleHeights() {
    const cells = Array.from(root.querySelectorAll('.CollectionMixAndMatch .Grid__Cell'));
    cells.forEach(cell => {
      const title = cell.querySelector('.ProductItem__Title');
      if (title) title.style.minHeight = '';
    });

    if (!TITLE_ALIGN_MQ.matches) return;

    const visible = cells.filter(cell => cell.offsetWidth > 0 && getComputedStyle(cell).display !== 'none');

    for (let i = 0; i < visible.length; i += 2) {
      const pairTitles = visible.slice(i, i + 2)
        .map(cell => cell.querySelector('.ProductItem__Title'))
        .filter(Boolean);
      if (!pairTitles.length) continue;

      const maxHeight = Math.max(...pairTitles.map(title => title.offsetHeight));
      pairTitles.forEach(title => {
        title.style.minHeight = maxHeight + 'px';
      });
    }
  }

  function scheduleMobileTitleHeights() {
    cancelAnimationFrame(titleAlignRaf);
    titleAlignRaf = requestAnimationFrame(syncMobileTitleHeights);
  }

  function initMobileTitleHeights() {
    scheduleMobileTitleHeights();
    TITLE_ALIGN_MQ.addEventListener('change', scheduleMobileTitleHeights);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleMobileTitleHeights);
    }
  }

  function initFilters() {
    const filterBtns = root.querySelectorAll('[data-filter]');

    filterBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        filterBtns.forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');

        const filter = btn.dataset.filter;
        root.querySelectorAll('.Grid__Cell').forEach(cell => {
          const item = cell.querySelector('.ProductItem');
          if (!item) return;
          const tags = (item.dataset.mmTags || '').split(',').map(t => t.trim());
          cell.style.display = (filter === 'mm_alle' || tags.includes(filter)) ? '' : 'none';
        });
        scheduleMobileTitleHeights();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCore);
  } else {
    initCore();
  }
})();
